// extracted by mini-css-extract-plugin
export default {"skillNode":"SkillNode_skillNode__zI2rj"};